<template>
  <v-select
    v-if="version >= '1.5.0'"
    :rules="requiredRules"
    :items="permissions"
    label="Permissões"
    v-model="user.permissions"
    :multiple="true"
  />
  <v-select
    v-else
    :rules="requiredRules"
    :items="permissions"
    label="Permissão"
    v-model="user.permission"
  />
</template>
<script>
import Service from '@/services/UserService'
import { requiredRules } from '../../../utils/rules'

export default {
  name: 'PermissionSelector',

  model: {
    prop: 'user'
  },

  props: {
    user: Object,
    required: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    permissions: []
  }),

  computed: {
    version () { return this.$versionable.versions.users },
    requiredRules () {
      return this.required
        ? requiredRules(this.version >= '1.5.0' ? this.user.permissions : this.user.permission)
        : []
    }
  },

  mounted () { this.findPermissions() },

  methods: {
    findPermissions () {
      Service.findPermissions()
        .then(response => { this.permissions = response.data })
        .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
    }
  }
}
</script>
